import { DayProgram } from './day-program.model'
import { AreaProgram } from './area.program.model';

export class Program {
    public Days : Array<DayProgram>;
    public Areas: Array<AreaProgram>;
}



// WEBPACK FOOTER //
// ./src/models/program.model.ts